import t from"react";import{MdIcon as r}from"./MdIcon.js";import{mdiTwitter as e}from"@mdi/js";const i=({id:i="twitter",title:o="Twitter",...m})=>t.createElement(r,{id:i,title:o,path:e,...m});export{i as TwitterIcon};
